module.exports = __webpack_public_path__ + "img/banner-info-greenn.56adb9c7.png";